// מעקב אחר עדכונים של Service Worker וניהול רענון משתמש
import { ref, onMounted } from 'vue'

export function usePwaUpdater() {
  const updateAvailable = ref(false)
  let waitingWorker = null

  // שליחת הודעה ל-SW להיכנס מיד
  const triggerUpdate = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' })
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload()
      })
    }
  }

  onMounted(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then((reg) => {
        if (!reg) return

        // זיהוי SW חדש שמחכה להחליף
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing
          if (!newWorker) return

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              waitingWorker = newWorker
              updateAvailable.value = true
            }
          })
        })

        // כאשר התחלף ה-SW → רענון
        // navigator.serviceWorker.addEventListener('controllerchange', () => {
        //   window.location.reload()
        // })
      })

      // טיפול בקריסה ב-dynamic imports
      window.addEventListener('error', (e) => {
        if (e.message?.includes('Failed to fetch dynamically imported module')) {
          // ניסיון לתקן בצורה שקטה
          navigator.serviceWorker.getRegistration().then((reg) => {
            reg?.waiting?.postMessage({ type: 'SKIP_WAITING' })
          })
        }
      })
    }
  })

  return { updateAvailable, triggerUpdate }
}
